import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

export interface IOnHandResendParams {
  exceptionNumber: number;
  email1?: string;
  email2?: string;
  email3?: string;
  email4?: string;
  reason: string;
}

export interface IOnHandResendResponse {
  message?: string;
  resendCount?: number;
  canResendNotice?: boolean;
  resendNotice?: any;
}

/**
 * API to resend On Hand notice emails
 * @param params - Resend parameters including exception number, emails and reason
 * @returns - Response from the API
 */
export const OnHandResendAPI = async (
  params: IOnHandResendParams,
): Promise<IOnHandResendResponse> => {
  try {
    const staticHeaders = getTrackingHeadersMap(ApiType.ON_HAND_ENTRY_CREATE);
    const headers = {
      ...staticHeaders,
      "OSD-Exception-Number": params.exceptionNumber?.toString(),
    };
    
    const emailAddresses = [
      params.email1,
      params.email2,
      params.email3,
      params.email4
    ].filter((email): email is string => !!email?.trim());

    const response = await axios.post(
      `${getUrl(ApiType.ON_HAND_ENTRY_CREATE)}/${params.exceptionNumber}/resend-notice`,
      {
        emailAddresses,
        resendReason: params.reason,
      },
      { headers },
    );
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.updateOnHandEntry, {
      badRequestOrder: "errorsFirst",
    });
  }
};
